import { CustomButton } from '@shared/buttons';
import { NotificationIcon } from '@shared/icons';

import './NotificationButton.scss';

function Notifications() {
  const numBadge = 3;
  return (
    <CustomButton className="nav-button btn-notifications" color="link">
      <NotificationIcon />
      <div className="badge">
        <span>{numBadge}</span>
      </div>
    </CustomButton>
  );
}

export default Notifications;
